import { render, staticRenderFns } from "./auditFair.vue?vue&type=template&id=705f8be0&scoped=true&"
import script from "./auditFair.vue?vue&type=script&lang=js&"
export * from "./auditFair.vue?vue&type=script&lang=js&"
import style0 from "./auditFair.vue?vue&type=style&index=0&id=705f8be0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f8be0",
  null
  
)

export default component.exports